
    import '/home/ec2-user/Youlify-Design/components/splitter/index.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["splitter-demo-size","splitter-demo-control","splitter-demo-vertical","splitter-demo-collapsible","splitter-demo-multiple","splitter-demo-group","splitter-demo-nested-in-tabs","splitter-demo-lazy","splitter-demo-debug"],
  getter: () => import(/* webpackChunkName: "meta__components__en-US" */'/home/ec2-user/Youlify-Design/components/splitter/index.en-US.md?type=demo')
};